import React, { useRef, useEffect } from "react";
import { StatusIcon } from "../../../assets/svg/StatusIcon";
import { Formik, Form, Field } from "formik";
import { InputSection } from "../components/Form";
import { DropDown } from "../../../ui/DropDown";
import Input from "../../../ui/Input";
import { postEndpoint, GetHook, putEndpoint } from "../../../api/api";
import {
  ORGANISATION_TYPE_URL,
  ORGANISATION_ASPECT_URL,
} from "../../../api/urls";
import { get } from "../../../utils/get";
import { parseDropdown } from "../../../utils/parseDropdown";
import { toast } from "react-toastify";
import { OrganisationTypeSchema } from "../../../utils/validationSchema/OrganisationTypeSchema";

interface IProps {
  setHandleSubmit?: any;
  closseModal: any;
  editData?: any;
  organisationTypes?: any;
  setOragisationTypes?: any;
}

const AddOrganizationType = ({
  setHandleSubmit,
  closseModal,
  editData,
  organisationTypes,
  setOragisationTypes,
}: IProps) => {
  const formRef: any = useRef<any>(null);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();

  const { data: typeAspect } = GetHook(ORGANISATION_ASPECT_URL);

  const { id } = editData;

  const isAddMode = !id;

  useEffect(() => {
    if (!isAddMode) {
      const newEditData = {
        name: get(editData, "name"),
        notes: get(editData, "notes"),
        aspect: {
          value: get(editData, "organisation_aspect_id"),
          label: get(editData, "organisation_aspect.name"),
        },
      };
      const fields = ["name", "aspect", "notes"];

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );
    }
  }, []);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  const addOrganisationType = (values) => {
    const payload = {
      name: get(values, "name"),
      notes: get(values, "notes"),
      organisation_aspect_id: get(values, "aspect.value"),
    };

    createReq(ORGANISATION_TYPE_URL, payload);
  };

  const editOrganisationType = (values) => {
    const payload = {
      name: get(values, "name"),
      notes: get(values, "notes"),
      organisation_aspect_id: get(values, "aspect.value"),
    };

    updateReq(`${ORGANISATION_TYPE_URL}/${id}`, payload);
  };

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error(get(data, "message.name"));
    }
    if (!pending && complete && !error) {
      closseModal();
      toast.success("Organisation Type added successfully");
    }

    return () => {};
  }, [createRes]);

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (!pending && complete && data && !error) {
      toast.success("Organisation Type updated successfully");
      closseModal();
    }
  }, [closseModal, organisationTypes, updateRes]);

  const options = parseDropdown(typeAspect);
  return (
    <Formik
      initialValues={{
        name: "",
        description: "",
        aspect: "",
      }}
      validationSchema={OrganisationTypeSchema}
      innerRef={formRef}
      onSubmit={
        isAddMode
          ? (values) => addOrganisationType(values)
          : (values) => editOrganisationType(values)
      }
    >
      {() => (
        <Form>
          <InputSection>
            <Field
              type="text"
              name="name"
              placeholder="enter  name"
              label="Organization type name"
              component={Input}
            />
          </InputSection>
          <InputSection>
            <Field
              name="aspect"
              dropdownLabel="Type aspect"
              component={DropDown}
              options={options}
              width="90%"
              backgroundColor="#F5F6FB"
            />
          </InputSection>

          <InputSection>
            <Field
              type="textarea"
              name="notes"
              placeholder="Description"
              label="Type description"
              component={Input}
            />
          </InputSection>
        </Form>
      )}
    </Formik>
  );
};

export default AddOrganizationType;
